import styled from '@emotion/styled';
import { Button } from '@naf-simba/elements-buttons';
import { simbaStyled } from '@naf-simba/theme';
import { Text } from '@naf/text';
import { breakpoints, spacing } from '@naf/theme';
import { UserInteraction } from '@naf/user-interaction';
import { Tag } from '@naf-simba/elements-tag';
import { CheckCircle } from '@styled-icons/material/CheckCircle';
import { GridRow } from '@naf/grid';
import { nafColor } from '@nafcore/theme';

export const StyledTag = styled(Tag)`
  margin-bottom: ${spacing.space24};
  margin-top: -${spacing.space24};
  display: flex;
  width: min-content;

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space8};
  }
`;

export const OilChange = styled.div`
  margin-bottom: ${spacing.space12};

  @media (max-width: ${breakpoints.s}) {
    margin-bottom: 0;
  }

  h2 {
    margin: 0 0 ${spacing.space8} !important;
  }
  p {
    margin: 0 !important;
  }
`;

export const Row = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  width: 100%;
  max-width: 80px;
`;

export const Search = styled.div`
  display: flex;
  margin-top: ${spacing.space32};

  @media (max-width: ${breakpoints.m}) {
    margin-top: ${spacing.space20};
  }

  @media (max-width: ${breakpoints.s}) {
    margin-top: ${spacing.space16};

    > div {
      flex-grow: 1;
    }
  }
`;

export const StyledButton = simbaStyled(Button)(({ theme }) => ({
  '&&': {
    marginLeft: theme.spacing(4),
    [`@media (max-width: ${breakpoints.s})`]: {
      marginLeft: theme.spacing(2),
    },
  },
}));

export const StyledCheckCircle = styled(CheckCircle)`
  color: ${nafColor.information.successDark};
`;

export const LookupResultSuccess = styled.div`
  margin-top: ${spacing.space8};

  a {
    margin-top: ${spacing.space16};
  }
`;

export const LookupResultError = styled.div`
  margin-top: ${spacing.space16};

  h3 {
    margin: 0 0 ${spacing.space8};
  }
  p {
    margin: 0;
  }
  a {
    margin-top: ${spacing.space16};
  }
`;

export const VehicleText = styled.div`
  display: flex;
  align-items: center;
  margin: ${spacing.space16} 0;

  > *:first-child {
    margin-right: ${spacing.space4};
  }
`;

export const SuccessText = styled(Text)`
  display: inline-flex;
  margin-left: ${spacing.space8} !important;
`;

export const Summary = styled.div`
  display: flex;
  flex-direction: column;
  margin-bottom: ${spacing.space16};
  max-width: 512px;

  h3 {
    margin: 0 0 ${spacing.space8};
  }

  h4,
  p {
    margin: 0;
  }

  @media (max-width: ${breakpoints.s}) {
    margin: ${spacing.space20} 0;
    max-width: 100%;
  }
`;

export const SummaryRow = styled(GridRow)`
  padding: ${spacing.space16} 0;
  border-bottom: 1px solid rgba(0, 0, 0, 0.12);
  grid-gap: 0 !important;

  h5 {
    padding-right: ${spacing.space32};
  }
`;

export const SpinnerWrapper = styled.div`
  margin-top: ${spacing.space24};
  width: fit-content;

  @media (max-width: ${breakpoints.s}) {
    margin-left: auto;
    margin-right: auto;
  }
`;

export const StyledUserInteraction = styled(UserInteraction)`
  margin-bottom: ${spacing.space16};
  width: fit-content;
`;
